






























































































































































































































































































































































































































































































































































































































































































































































































import Fragment from "../../Fragment.vue";
import ApiPaginator from "./ApiPaginator.vue";
import IconButton from "../../IconButton.vue";
import Tooltip from "../../Tooltip.vue";
import ValidationResult from "../../../modules/transactions/models/ValidationResult";
// '@models/ValidationResult';

import Vue, { PropType } from "vue";
import ApiSearch, { ApiSearchColumn, ColumnType } from "../models/ApiSearch";
import { getAltRow, getHeaderClasses, getFieldClasses } from "@/utils/classes";
import { PaginatedPager } from "@/models/Pager";
import { FilteringModel, SortingModel, SortOrder } from "@/services/filtering";

import ServerSideSearchApi from "../services/ServerSideSearchApi";
import { debounce } from "debounce";
import eventBus from "@/services/eventBus";
import DateInput from "@/components/DateInput.vue";
import CheckBox from "@/components/CheckBox.vue";
import SpecialDimensionFilterButton from "@/components/SpecialDimensionFilterButton.vue";
import SpecialDimensionFilterValue from "@/modules/specialDimension/models/SpecialDimensionFilter";
import { saveSearchState, getSearchState } from "../services/searchStateMemory";

import ApiSearchComponent from "@/components/apiSearch/components/ApiSearch.vue";
import dayjs from "dayjs";
import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import { vAlign } from "@progress/kendo-drawing";
import Transaction from "@/modules/transactions/models/Transaction";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import basket, { ReconBasketStore, ReconModeFilterSnapshot } from "@/modules/transactions/services/ReconBasketStore";
import { t } from "@/plugins/i18n";

interface Data {
  /** Local API instance */
  api: ServerSideSearchApi;
  /** CurrentPage, PageSize, SearchText, Filter, Sorting container */
  apiSearch: ApiSearch;
  /** Displayed items */
  items: object[];
  /** Total item count */
  totalItems: number;
  /** Displayed columns mapped as "ApiSearchColumn" */
  localColumns: ApiSearchColumn[];

  /** Dispaly in Table (or List) view - @default true */
  isTableView: boolean;
  /** Display filters - @default false */
  isFilterVisible: boolean;

  loading: boolean;
  eventListenersAdded: boolean;

  filters: boolean;
  selectedTransStats: any[];
  selectedCurrencies: any[];
  selectedPeriod: string | null;
  selectedBookTypes: any[];

  isStorno: boolean;
  isMod: boolean;
  typeManual: boolean;
  typeAuto: boolean;
  startDate: string;
  endDate: string;
  today: string;
  /** A lenyíló elemei: text = "név állapot" (megjelenítés), value = periódus név (szűrő-érték). */
  periods: { text: string; value: string }[];
  periodSelectorVisible: boolean;
  periodResults: any[];
  searchText: string;

  selectedLedgers: any[];
  selectedItemStatus: number;

  /** Melyik ellentételező popover van nyitva: '' | 'K' (kontírozás) | 'O' (összeg) */
  reverseMenu: string;
  /** Az ellentételező tétel könyvelési dátuma a popoverben */
  reverseDate: string;

  /** K2D w_specdim: az alkalmazott speciális dimenzió Tól/Ig szűrő */
  specDimFilter: SpecialDimensionFilterValue;

  /** Aktív ellenőrzés-mód (Ellenőrzések lenyíló): '' | 'balance' | 'posting' | 'mixed' */
  checkType: string;
  /** Az Ellenőrzések lenyíló elemei (felirat + tooltip) */
  checkOptions: { value: string; title: string; description: string }[];

  /** Főkönyvi szám (kód) szűrő — '' = nincs; fej-lista: van-e tétele ezen az fksz-en */
  accno: string;
  /** A Főkönyvi szám választó listája (az "ig" dátum évének mmbokaccno sorai) */
  invoiceMirrors: any[];
  /** Összepontozó kosár + mód (singleton; a capsule és az auto-lenyitás olvassa) */
  basket: ReconBasketStore;
}

/** A searchStateMemory-ba mentett szűrő-pillanatkép: oldalon belüli navigálást túléli, F5-t nem. */
type LedgerSearchSnapshot = Pick<
  Data,
  | "apiSearch"
  | "selectedTransStats"
  | "selectedCurrencies"
  | "selectedPeriod"
  | "selectedBookTypes"
  | "isStorno"
  | "isMod"
  | "typeManual"
  | "typeAuto"
  | "startDate"
  | "endDate"
  | "specDimFilter"
  | "checkType"
  | "accno"
>;

interface Methods {
  showItem(item: any): boolean;
  /** Összepontozás-mód indítása: szűrő-pillanatkép mentése, majd év + könyvelt státusz (+ fksz) szűrés */
  enterReconMode(payload: { year: number; accno: string }): void;
  /** Ellenőrzés választása: aktív összepontozás-módból automatikusan kilép, majd bekapcsolja az ellenőrzést */
  selectCheck(value: string): void;
  /** Összepontozás-mód vége: a mód előtti szűrők visszaállítása */
  exitReconMode(): void;
  applyReconSnapshot(snapshot: ReconModeFilterSnapshot | null): void;
  openBasket(): void;
  onAccnoSelected(item: any): void;
  loadInvoiceMirrors(): Promise<void>;
  refreshClick(): void;
  resetFilterClick(): void;
  resetSortClick(): void;

  /** Load items */
  changeHandler(): Promise<void>;
  pagerChanged(pager: PaginatedPager): void;

  getFieldOrder(field: string): SortOrder;
  toggleSort(field: string): void;

  getHeaderClasses(column: ApiSearchColumn): string;
  getFieldClasses(column: ApiSearchColumn): string;
  getAltRow(i: number): string;
  toggleExtraFilterVisibility(): void;
  onToggleSpecDimColumns(): void;
  addFilterWIdthEventListeners(): void;

  filterPeriod(): void;
  filterCurrency(e: any): void;
  filterBookType(e: any): void;
  filterTransStat(e: any): void;
  toggleAllCurrencies(): void;
  toggleAllBookTypes(): void;
  toggleAllTransStats(): void;

  resetStartDate(): void;
  resetEndDate(): void;
  formatDate(date: string | Date): string;
  searchPeriodResults(e: any): void;
  loadPeriodResults(): Promise<void>;
  togglePeriodSelector(): void;
  applyPeriodFilter(): void;
  applyPanelFilter(): void;
  addToSelected(e: any): void;
  setStatus(e: number): void;
  setSelected(e: any): void;
  setSelectedItemStatus(e: number): void;

  /** Ellentételező popover nyitása ('K'/'O') vagy zárása (''); nyitáskor a dátumot az első kijelölt tétel könyvelési dátumára állítja. */
  openReverse(mode: string): void;
  /** A popover megerősítése: a kijelölt tételeket és a megadott dátumot a megfelelő eventben felküldi a szülőnek. */
  emitReverse(mode: string): void;
  /** A popover dátummezőjének fókuszálása (a DateInput fókuszra ki is nyitja a naptárat). */
  focusReverseDate(mode: string, attempt?: number): void;

  /** Speciális dimenzió szűrő alkalmazása: első oldalra ugrás + lista frissítése. */
  applySpecDimFilter(): void;
  /** Egy dimenzió Tól/Ig párjának törlése a capsule-ról. */
  clearSpecDim(c: any): void;
}

interface Computed {
  hasCustomTable: boolean;
  hasCustomTableBody: boolean;
  hasDetails: boolean;
  hasListView: boolean;
  hasFilters: boolean;
  hasNoItems: boolean;
  periodColumns: any[];
  hasSelectedTransaction: boolean;
  /** Aktív spec. dimenzió szűrő-capsule-ok ("Munkaszám: a - b" alakban) */
  specDimCapsules: { key: string; text: string; from: string; to: string }[];
  /** Az aktív ellenőrzés-mód felirata a piros capsule-hoz */
  checkLabel: string;
  reconLabel: string;
  statusActions: { value: number; title: string; disabled: boolean }[];
}

interface Props {
  /** Page title */
  title: string;

  /** Bővített nézet: a sor végi spec. dimenzió oszlopok láthatósága (a kapcsoló-gomb aktív állapota). */
  specDimColumnsVisible: boolean;

  //! Search API
  /** API path */
  url: string;
  /** Selectable page sizes - @default [10,20,50,100] */
  baseSizes: number[];
  /** Debounce delay - @default 0 */
  delay: number;

  hideOnEmpty: boolean;

  openDetailsByDefault: boolean;

  //! Top Buttons
  /** Display "Create" button with the given title */
  create: string;
  /** Display "Remove Filter" button - @default true */
  resetFilter: boolean;
  /** Display "Remove Sort" button - @default true */
  resetSort: boolean;
  /** Display "Search Box" - @default true */
  search: boolean;
  /** Displayed Placeholder inside the Search Box @default "Keresés" */
  searchPlaceholder: string;
  /** Display "Filter" button - @default false
   * @todo passed props
   * @todo default view */
  showFilter: boolean;
  /** Display "List/Table view" buttons - @default false
   * @todo passed props
   * @todo default view */
  multiView: boolean;
  /** Display "Refresh" button - @default true */
  refresh: boolean;
  /** Display divider - @default true */
  showDivider: boolean;
  /** Display extra date picker - @default false */
  showExtraDateFilter: boolean;

  //! Table
  /** Raw columns - @default [] */
  columns: ApiSearchColumn[];
  /** List should be filterable - @default true */
  filterable: boolean;
  /** List should be sortable - @default true */
  sortable: boolean;
  /** Same width for every col - @default false */
  fixedTable: boolean;
  /** Maximum column width for every col - @default 200 */
  maxColWidth: number;
  /** Replace "details" prop name - @default "details" */
  detailsField: string;
  /** Display the whole content on hover - @default false */
  displayTitles: boolean;
  hasPager: boolean;
  exclusiveItems: number[];
  /** Csak ezek a tranzakció ID-k látszanak (minden más szűrő figyelmen kívül) — tranzakció import "Megtekintés" */
  exclusiveIds: number[];
  /** Extra filters passed through as a prop */
  extraFilter: FilteringModel | undefined;
  multiselect: boolean;
  /** For setting the unique eventbus name **/
  name: string;
  /** Filter field grows with text input */
  filterFieldAutoGrow: boolean;

  transStats: any[];
  currencies: any[];
  bookTypes: any[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { Fragment, ApiPaginator, IconButton, Tooltip, DateInput, CheckBox, SpecialDimensionFilterButton, LookupComboBox, /*ApiSearchComponent*/ },

  props: {
    title: String,

    specDimColumnsVisible: { type: Boolean, default: false },

    hideOnEmpty: { type: Boolean, default: false },

    url: String,
    baseSizes: {
      type: Array as () => number[],
      default: () => [10, 20, 50, 100],
    },
    delay: { type: Number, default: 0 },

    openDetailsByDefault: { type: Boolean, default: false },

    create: String,
    resetFilter: { type: Boolean, default: true },
    resetSort: { type: Boolean, default: true },
    search: { type: Boolean, default: true },
    searchPlaceholder: { type: String, default: t("Kereses") },
    showFilter: { type: Boolean, default: false },
    multiView: { type: Boolean, default: false },
    refresh: { type: Boolean, default: true },
    showDivider: { type: Boolean, default: true },
    showExtraDateFilter: { type: Boolean, default: false },
    filterFieldAutoGrow: { type: Boolean, default: true },

    columns: {
      type: Array as () => ApiSearchColumn[],
      default: () => new Array<ApiSearchColumn>(),
    },
    filterable: { type: Boolean, default: true },
    multiselect: { type: Boolean, default: false },
    sortable: { type: Boolean, default: true },
    fixedTable: { type: Boolean, default: false },
    extraFilter: { type: Object as () => FilteringModel, default: undefined },
    maxColWidth: { type: Number, default: 200 },
    detailsField: { type: String, default: "details" },
    displayTitles: { type: Boolean, default: false },
    hasPager: { type: Boolean, default: true },
    name: { type: String, default: "api-search-page" },
    exclusiveItems: {
      type: Array as () => number[],
      default: () => {
        return [];
      },
    },

    exclusiveIds: {
      type: Array as () => number[],
      default: () => [],
    },

    transStats: {
      type: Array as () => any[],
      default: () => [ { id: 1, name: "-"}, ],
    },

    currencies: {
      type: Array as () => any[],
      default: () => [ { id: 1, name: "-"}, ],
    },

    bookTypes: {
      type: Array as () => any[],
      default: () => [ { id: 1, name: "-"}, ],
    },
  },

  data(): Data {
    const base: Data = {
      api: new ServerSideSearchApi(),
      apiSearch: new ApiSearch(),
      items: [],
      totalItems: 0,
      localColumns: [],
      isTableView: true,
      isFilterVisible: false,
      loading: false,
      eventListenersAdded: false,
      filters: false,
      selectedTransStats: [],
      selectedCurrencies: [],
      selectedPeriod: null,
      selectedBookTypes: [],
      isStorno: false,
      isMod: false,
      typeManual: true,
      typeAuto: false,
      startDate: dayjs(new Date("2000-01-01")).format("YYYY-MM-DD"),
      endDate: dayjs(new Date()).format("YYYY-MM-DD"),
      today: dayjs(new Date()).format("YYYY-MM-DD"),
      periods: [],
      periodSelectorVisible: false,
      periodResults: [],
      searchText: "",

      selectedLedgers: [],
      selectedItemStatus: 7,

      reverseMenu: '',
      reverseDate: '',

      specDimFilter: { from1: "", to1: "", from2: "", to2: "", from3: "", to3: "", from4: "", to4: "" },

      checkType: "",
      checkOptions: [
        { value: "balance", title: t("TartozikKovetelEgyenleg"), description: t("ATartozikEsKovetelOldalOsszege") },
        { value: "posting", title: t("Kontirozas"), description: t("AKontirozottLekonyveltOsszegNemEgyezik") },
        { value: "mixed", title: t("TKOldalonBeluliVegyesElojel"), description: t("EgyOldalonTartozikVagyKovetelBelul") },
      ],

      accno: "",
      invoiceMirrors: [],
      basket,
    };

    // A panel-szűrők a mentett pillanatképből már KEZDŐÉRTÉKKÉNT visszatöltődnek — így a
    // watchereik nem sülnek el, nem indul felesleges API-hívás. F5 után nincs pillanatkép
    // (a tár memóriában él), ilyenkor tiszta alapértelmezésekkel indul az oldal.
    const saved = getSearchState<LedgerSearchSnapshot>(this.$props.name);
    if (saved) {
      base.selectedTransStats = saved.selectedTransStats;
      base.selectedCurrencies = saved.selectedCurrencies;
      base.selectedPeriod = saved.selectedPeriod;
      base.selectedBookTypes = saved.selectedBookTypes;
      base.isStorno = saved.isStorno;
      base.isMod = saved.isMod;
      base.typeManual = saved.typeManual;
      base.typeAuto = saved.typeAuto;
      base.startDate = saved.startDate;
      base.endDate = saved.endDate;
      base.specDimFilter = saved.specDimFilter;
      base.checkType = saved.checkType ?? "";
      base.accno = saved.accno ?? "";
    }

    // Az összepontozás-mód a böngészőn KÍVÜL ért véget (a pontozás-szerkesztő mentése): a mód
    // előtti szűrők a kezdőértékekbe kerülnek — itt, hogy a watcherek ne indítsanak plusz betöltést.
    const pending = basket.takeSnapshot();
    if (pending) {
      base.selectedTransStats = pending.selectedTransStats;
      base.startDate = pending.startDate;
      base.endDate = pending.endDate;
      base.accno = pending.accno;
      base.checkType = pending.checkType;
      base.typeManual = pending.typeManual;
      base.typeAuto = pending.typeAuto;
    }

    return base;
  },

  async beforeMount() {
    /** Create new ApiSearchColumn from params */
    
    this.localColumns = this.$props.columns.map((c: unknown) => new ApiSearchColumn(c as Partial<ApiSearchColumn>));

    // TODO: default filter support
    let filter = this.$props.filterable
      ? new FilteringModel().values(
          this.localColumns
            .filter((x) => x.filterable && !x.multiselect)
            .map((x) => ({ field: x.field ?? "" }))
            .filter((x) => !!x.field)
        )
      : undefined;

    const extraFilterCols = this.localColumns.filter((x) => x.extraFilterValue);
    extraFilterCols.forEach((e) => {
      if (filter) {
        filter = filter.value(e.field ?? "", e.extraFilterValue ?? "");
      }
    });

    this.localColumns
      .filter((x) => x.multiselect)
      .forEach((e) => {
        if (filter) {
          filter = filter.multiSelect(
            e.multiselectField ?? "",
            e.multiselectOptions ?? [],
            typeof e.multiselectSelect === "number" && e.multiselectSelect > 1
              ? [e.multiselectSelect]
              : e.multiselectOptions?.map((x) => x.value)
          );
        }
      });

    this.localColumns
      .filter((x) => x.range)
      .forEach((e) => {
        if (filter) {
          filter = filter.range(e.field ?? "");
        }
        // console.log(e);
      });

    // TODO: default filter support
    const sort = this.sortable
      ? new SortingModel().capitalize().fields(
          this.localColumns
            .filter((x) => x.sortable)
            .map((x) => ({ field: x.field ?? "", text: x.title ?? "" }))
            .filter((x) => !!x.field && !!x.text)
        )
      : undefined;

    /** Init ApiSearch */
    this.apiSearch = new ApiSearch({
      pageSize: this.$props.hasPager ? this.$props.baseSizes[0] : 1000,
      filter: filter,
      extraFilter: this.$props.extraFilter,
      sort: sort,
      searchText: "",
    });

    // Mentett pillanatképnél a korábbi ApiSearch példány él tovább (oszlopszűrő-értékek,
    // rendezés, keresőszöveg) a frissen épített helyett. A lapozást az első betöltésre
    // normalizáljuk (az ApiPaginator 1. oldalról indul, a totalItems-watchere vissza is
    // állítaná), a mentett oldalra az első betöltés UTÁN léptetünk.
    const saved = getSearchState<LedgerSearchSnapshot>(this.$props.name);
    const savedPage = saved ? saved.apiSearch.currentPage : 1;
    if (saved) {
      saved.apiSearch.currentPage = 1;
      saved.apiSearch.pageSize = this.apiSearch.pageSize;
      this.apiSearch = saved.apiSearch;
    }

    if (this.$props.url != "") {
      await this.changeHandler(); // api call to the backend
    }
    this.changeHandler = debounce(this.changeHandler, this.$props.delay);

    // Mentett oldalszám visszaállítása a meglévő api-pager:set-page eseménnyel (a közös
    // ApiPaginator érintetlen; a saját EventBus 1 payloadot visz át, ezért csak az oldalszám
    // állítható vissza, a lapméret nem). A nextTick megvárja a paginator totalItems-watcherének
    // 1. oldalra állítását, így a mentett oldalé az utolsó szó; a pagerChanged erre tölti be
    // a mentett oldalt (tudatos második kérés).
    if (savedPage > 1) {
      await this.$nextTick();
      eventBus.$emit("api-pager:set-page", savedPage);
    }
  },

  // Kilépéskor pillanatképet mentünk a teljes szűrőállapotról (memóriába — F5 törli),
  // hogy visszanavigáláskor ugyanez az állapot töltődjön vissza.
  beforeDestroy() {
    const snapshot: LedgerSearchSnapshot = {
      apiSearch: this.apiSearch,
      selectedTransStats: this.selectedTransStats,
      selectedCurrencies: this.selectedCurrencies,
      selectedPeriod: this.selectedPeriod,
      selectedBookTypes: this.selectedBookTypes,
      isStorno: this.isStorno,
      isMod: this.isMod,
      typeManual: this.typeManual,
      typeAuto: this.typeAuto,
      startDate: this.startDate,
      endDate: this.endDate,
      specDimFilter: this.specDimFilter,
      checkType: this.checkType,
      accno: this.accno,
    };
    saveSearchState(this.$props.name, snapshot);

    eventBus.$off(`${this.$props.name}:recon-mode-start`, this.enterReconMode);
    eventBus.$off(`${this.$props.name}:recon-mode-exit`, this.exitReconMode);
  },

  watch: {
    exclusiveItems() {
      this.changeHandler();
    },
    exclusiveIds() {
      this.applyPanelFilter();
    },
    /** Load items on Filter change */
    "apiSearch.searchText": {
      deep: true,
      handler(_: FilteringModel | undefined, old: FilteringModel | undefined) {
        // block refresh while it's undefined
        if (!old) return;
        this.changeHandler();
      },
    },

    /** Load items on Filter change */
    "apiSearch.filter": {
      deep: true,
      handler(_: FilteringModel | undefined, old: FilteringModel | undefined) {
        // block refresh while it's undefined
        if (!old) return;
        this.changeHandler();
      },
    },

    /** Load items Sort change */
    "apiSearch.sort": {
      deep: true,
      handler(_: SortingModel | undefined, old: SortingModel | undefined) {
        // block refresh while it's undefined
        if (!old) return;
        this.changeHandler();
      },
    },

    // A szűrőpanel értékei azonnal érvényesüljenek (mint a periódus/specdim szűrőnél) —
    // watcherrel, mert a modelleket a vezérlők ÉS a capsule-törlő X-ek is írják, így
    // minden út egy helyen frissít. (changeHandler debounce-olt, a gyors kattintások összevonódnak.)
    selectedTransStats() { this.applyPanelFilter(); },
    selectedCurrencies() { this.applyPanelFilter(); },
    selectedBookTypes() { this.applyPanelFilter(); },
    isStorno() { this.applyPanelFilter(); },
    isMod() { this.applyPanelFilter(); },
    typeManual() { this.applyPanelFilter(); },
    typeAuto() { this.applyPanelFilter(); },
    startDate() { this.applyPanelFilter(); },
    endDate(val: string, old: string) {
      // A Főkönyvi szám választó listája az "ig" dátum évéhez kötött
      if (dayjs(val).year() !== dayjs(old).year()) {
        this.loadInvoiceMirrors();
      }
      this.applyPanelFilter();
    },
    // Főkönyvi szám: összepontozás-módban a mód tárolt fksz-e (capsule, kosár-menü, sárga sor-kiemelés)
    // követi a szűrőt — az indító menüben választott szám csak kiindulás, a panelen átírható
    accno(value) {
      if (this.basket.mode.active) {
        this.basket.mode.accno = value || "";
      }
      this.applyPanelFilter();
    },
    // Ellenőrzés-mód: bekapcsoláskor a Manuális default-szűrő automatikusan lekerül (a régi
    // Ellenőrzések oldal sem szűrt típusra), kikapcsoláskor automatikusan visszakerül, ha nincs fent.
    checkType(val: string, old: string) {
      if (val && !old && this.typeManual) {
        this.typeManual = false;
      } else if (!val && old && !this.typeManual) {
        this.typeManual = true;
      }
      this.applyPanelFilter();
    },
  },

  created() {
    eventBus.$on(`${this.$props.name}:setSelected`, this.setSelected);

    eventBus.$on(`${this.$props.name}:get-items`, () => {
      this.$emit("items", this.items);
    });
    eventBus.$on(`${this.$props.name}:set-items`, (items) => {
      this.items = items;
    });

    eventBus.$on(`${this.$props.name}:reload`, () => {
      this.changeHandler();
    });

    // Összepontozás-mód: a kosár menü (ReconBasketMenu) indítja/zárja, a szűrőket ez a nézet állítja
    eventBus.$on(`${this.$props.name}:recon-mode-start`, this.enterReconMode);
    eventBus.$on(`${this.$props.name}:recon-mode-exit`, this.exitReconMode);
    this.loadInvoiceMirrors();

    eventBus.$on(`${this.$props.name}:close-details`, () => {
      this.items.forEach((item: unknown) => {
        Object.defineProperty(item, this.$props.detailsField, {
          value: false,
          writable: true,
          enumerable: true,
          configurable: true,
        });
      });
    });
  },

  methods: {
    async setStatus(status: number) {
      const response = await http.post<ApiResponse<ValidationResult[]>>(`general-ledger-transaction/set/status/${status}`, { selectedLedgers: this.items.filter((x: any) => x.selectedStatus) }).then(handleApiResponse);
      if(response.length > 0){
        response.forEach(mess =>{
          if(mess.isValid){
            eventBus.$emit("success", mess.message);
          }
          else{
            eventBus.$emit("error", mess.message);
          }
        })
      }
      await this.changeHandler();
    },

    setSelected(e: any) {
      e.selectedStatus = !e.selectedStatus;
    },
    setSelectedItemStatus(e){
      this.selectedItemStatus = e;
    },

    openReverse(mode: string) {
      this.reverseMenu = mode;
      if (mode) {
        const sel = (this.items as any[]).filter((x) => x.selectedStatus);
        this.reverseDate = (sel[0] && sel[0].accDate) || this.today;
        this.$nextTick(() => this.focusReverseDate(mode));
      }
    },
    // A gomb megnyomásakor mindjárt a dátummezőben legyen a fókusz: a DateInput fókuszra kijelöli
    // a szöveget ÉS lenyitja a naptárat, tehát felülgépelni és választani is azonnal lehet.
    // A v-menu tartalma lustán jön létre és a nyitó animáció alatt még rejtett (a rejtett elem
    // nem fókuszálható), ezért képkockánként újrapróbáljuk, amíg láthatóvá nem válik.
    focusReverseDate(mode: string, attempt = 0) {
      const picker = this.$refs[mode === 'K' ? 'reverseDateK' : 'reverseDateO'] as Vue | undefined;
      const input = picker?.$el?.querySelector('input') as HTMLInputElement | null;
      if (input && input.offsetParent !== null) {
        input.focus();
        return;
      }
      if (attempt < 20) {
        requestAnimationFrame(() => this.focusReverseDate(mode, attempt + 1));
      }
    },
    emitReverse(mode: string) {
      const sel = (this.items as any[]).filter((x) => x.selectedStatus);
      this.$emit(mode === 'K' ? 'reverseKontir' : 'reverseOsszeg', { items: sel, date: this.reverseDate });
      this.reverseMenu = '';
    },


    addToSelected(e: any) {
      if (e.selected) {
        this.periods = this.periods.filter((x) => x.value != e.name);
        if (this.selectedPeriod == e.name) {
          this.selectedPeriod = null;
          this.applyPeriodFilter();
        }
      }
      else {
        this.periods = [...this.periods, { text: `${e.name} ${e.status || ""}`.trim(), value: e.name }];
      }

      e.selected = !e.selected;
    },

    async searchPeriodResults(e: any) {
      if (e.key != "Enter") {
        return;
      }

      await this.loadPeriodResults();
    },

    async loadPeriodResults() {
      const results = await http.post<ApiResponse<any[]>>("general-ledger-transaction/search/periods", { searchText: this.searchText }).then(handleApiResponse);
      results.forEach((r: any) => { r.selected = this.periods.some((p) => p.value == r.name); });
      this.periodResults = results;
    },

    togglePeriodSelector() {
      this.periodSelectorVisible = !this.periodSelectorVisible;
      if (this.periodSelectorVisible) {
        this.loadPeriodResults();
      }
    },

    applyPeriodFilter() {
      eventBus.$emit("api-pager:set-page", 1);
      this.changeHandler();
    },

    /** Panel-szűrő változás: első oldalra ugrás + lista frissítése (watcherekből hívva). */
    applyPanelFilter() {
      eventBus.$emit("api-pager:set-page", 1);
      this.changeHandler();
    },

    // ---- Összepontozás-mód (kosár) ----

    enterReconMode(payload) {
      const snapshot: ReconModeFilterSnapshot = {
        selectedTransStats: [...this.selectedTransStats],
        startDate: this.startDate,
        endDate: this.endDate,
        accno: this.accno,
        checkType: this.checkType,
        typeManual: this.typeManual,
        typeAuto: this.typeAuto,
      };
      // Kiindulás: könyvelt fejek, a választott év, típus-szűrő nélkül (a gépi tételek is pontozandók),
      // az Ellenőrzés-mód kikapcsolva (két rejtett szűrő egymáson nem átlátható)
      const booked = this.$props.transStats.find((s: any) => Number(s.id) === 5);
      this.basket.startMode(payload.year, payload.accno, snapshot);

      this.checkType = "";
      this.typeManual = false;
      this.typeAuto = false;
      this.selectedTransStats = booked ? [booked.name] : [];
      this.startDate = `${payload.year}-01-01`;
      this.endDate = `${payload.year}-12-31`;
      this.accno = payload.accno || "";
    },

    // Ellenőrzés választása: az összepontozás-mód automatikusan kilép (a két rejtett szűrő egymáson
    // nem átlátható), a mód előtti szűrők visszaállnak, majd az ellenőrzés bekapcsol. A kosár tartalma megmarad.
    selectCheck(value: string) {
      if (this.basket.mode.active) {
        this.exitReconMode();
      }
      this.checkType = value;
    },

    exitReconMode() {
      const snapshot = this.basket.mode.snapshot;
      this.basket.endMode();
      const pending = this.basket.takeSnapshot();
      this.applyReconSnapshot(pending ?? snapshot ?? null);
    },

    applyReconSnapshot(snapshot) {
      if (!snapshot) return;
      this.selectedTransStats = [...snapshot.selectedTransStats];
      this.startDate = snapshot.startDate;
      this.endDate = snapshot.endDate;
      this.accno = snapshot.accno;
      this.checkType = snapshot.checkType;
      this.typeManual = snapshot.typeManual;
      this.typeAuto = snapshot.typeAuto;
    },

    openBasket() {
      eventBus.$emit(`${this.$props.name}:recon-basket-open`);
    },

    onAccnoSelected(item) {
      const value = item && item.accno && item.accno !== "-" ? String(item.accno) : "";
      if (value !== this.accno) {
        this.accno = value;
      }
    },

    async loadInvoiceMirrors() {
      const year = dayjs(this.endDate).year();
      try {
        this.invoiceMirrors = await http
          .get<ApiResponse<any[]>>(`general-ledger-transaction/detail/invoice-mirror/${year}`)
          .then(handleApiResponse);
      } catch {
        this.invoiceMirrors = [];
      }
    },

    formatDate(date: string | Date){
      return dayjs(date).format("YYYY. MM. DD.");
    },

    resetEndDate(){
      this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    },

    resetStartDate(){
      this.startDate = dayjs(new Date("2000-01-01")).format("YYYY-MM-DD");
    },

    filterPeriod(){
      this.selectedPeriod = null;
      this.applyPeriodFilter();
    },

    filterCurrency(i: any) {
      this.selectedCurrencies = this.selectedCurrencies.filter((x) => x != i.currency);
      this.selectedCurrencies = [...this.selectedCurrencies];
    },

    filterBookType(i: any) {
      this.selectedBookTypes = this.selectedBookTypes.filter((x) => x != i.name);
      this.selectedBookTypes = [...this.selectedBookTypes];
    },

    filterTransStat(i: any) {
      this.selectedTransStats = this.selectedTransStats.filter((x) => x != i.name);
      this.selectedTransStats = [...this.selectedTransStats];
    },
    toggleAllCurrencies() {
      this.selectedCurrencies =
        this.selectedCurrencies.length === this.$props.currencies.length ? [] : this.$props.currencies.map((x: any) => x.currency);
    },
    toggleAllBookTypes() {
      this.selectedBookTypes =
        this.selectedBookTypes.length === this.$props.bookTypes.length ? [] : this.$props.bookTypes.map((x: any) => x.name);
    },
    toggleAllTransStats() {
      this.selectedTransStats =
        this.selectedTransStats.length === this.$props.transStats.length ? [] : this.$props.transStats.map((x: any) => x.name);
    },

    applySpecDimFilter() {
      eventBus.$emit("api-pager:set-page", 1);
      this.changeHandler();
    },

    clearSpecDim(c: any) {
      this.specDimFilter = { ...this.specDimFilter, [c.from]: "", [c.to]: "" };
      this.applySpecDimFilter();
    },

    addFilterWIdthEventListeners(){
      if (this.filterFieldAutoGrow && !this.eventListenersAdded){

      this.eventListenersAdded = true;
      const inputs = document.querySelectorAll('.filter-field input');

      inputs.forEach(i => {
        let defaultWidth = 0; 
        const element = (i as any);

        const dummySpan = document.createElement('span');
        dummySpan.style.position = 'absolute';
        dummySpan.style.left = '-99999999px';
        dummySpan.style.fontSize = '12px';
        dummySpan.classList.add('maxWidth');
        element.parentNode.appendChild(dummySpan);

        i.addEventListener('input', () => {
          if (defaultWidth == 0){
            defaultWidth = i.clientWidth;
          }

          dummySpan.innerHTML = element.value.replace(/\s/g, '&nbsp;');
          const newWidth = dummySpan.offsetWidth;

          if (newWidth > defaultWidth){
            element.style.width = newWidth + 'px';
          }
        });
      });
    }
    },

    showItem(item: any) {
      if (this.$props.exclusiveItems.length < 0 || (item?.id ?? false)) {
        return true;
      } else {
        if (this.$props.exclusiveItems.includes(Number(item.id))) {
          return false;
        } else return true;
      }
    },

    refreshClick(): void {
      eventBus.$emit("api-pager:set-page", 1);
      this.changeHandler();
    },

    // "Szűrés eltávolítása": az oszlopszűrők ÉS a panel-szűrők (capsule-ök) visszaállítása.
    // Nem üresre, hanem az ALAPÉRTÉKRE — a Manuális és a dátumtartomány alapból kitöltött.
    resetFilterClick(): void {
      this.apiSearch.resetFiltering();

      this.selectedPeriod = null;
      this.selectedCurrencies = [];
      this.selectedBookTypes = [];
      this.isStorno = false;
      this.isMod = false;
      this.typeManual = true;
      this.typeAuto = false;
      // Összepontozás-módban az állapot ("Könyvekben szerepel") és a pontozás évének dátumtartománya kötött, marad
      if (!this.basket.mode.active) {
        this.selectedTransStats = [];
        this.startDate = dayjs(new Date("2000-01-01")).format("YYYY-MM-DD");
        this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
      }
      this.specDimFilter = { from1: "", to1: "", from2: "", to2: "", from3: "", to3: "", from4: "", to4: "" };
      this.checkType = "";

      // Az import "Megtekintés" ID-szűrője is szűrő — a gazda-nézet a query-ből veszi, ezért esemény
      if (this.$props.exclusiveIds.length) {
        this.$emit("clearExclusiveIds");
      }

      // A panel-mezők watcherei is indítanának újratöltést, de csak a ténylegesen megváltozottak;
      // ez a hívás garantálja, hogy egyetlen (debounce-olt) keresés mindenképp lefusson.
      this.applyPanelFilter();
      this.$emit("reset-filtering");
    },

    resetSortClick(): void {
      this.apiSearch.resetSorting();
      this.$emit("reset-sorting");
    },

    async changeHandler(): Promise<void> {
      const extrafilter = new FilteringModel()
        // A backend sima string-listát vár a selectedOptions-ben (mint a többi multiSelect-nél,
        // amelyek any[]-ként típusozottak) — ezért cast, nem FilterOption-csomagolás.
        .multiSelect("selectedPeriods", (this.selectedPeriod ? [this.selectedPeriod] : []) as any, true)
        // Konkrét ID-lista (tranzakció import "Megtekintés") — a backend ilyenkor minden más szűrőt kihagy
        .multiSelect("selectedIds", this.exclusiveIds.map((x: number) => String(x)) as any, true)
        .multiSelect("selectedTransStats", this.selectedTransStats, true)
        .multiSelect("selectedCurrencies", this.selectedCurrencies, true)
        .multiSelect("selectedBookTypes", this.selectedBookTypes, true)
        .value("isStorno", this.isStorno.toString())
        .value("isMod", this.isMod.toString())
        .value("typeAuto", this.typeAuto.toString())
        .value("typeManual", this.typeManual.toString())
        .value("startDate", dayjs(this.startDate).format("YYYY-MM-DD"))
        .value("endDate", dayjs(this.endDate).format("YYYY-MM-DD"))
        // K2D w_specdim: speciális dimenzió Tól/Ig — ha bármelyik kitöltött, a backend
        // K2D-hűen az összes többi szűrőt figyelmen kívül hagyja.
        .value("specDim1From", this.specDimFilter.from1)
        .value("specDim1To", this.specDimFilter.to1)
        .value("specDim2From", this.specDimFilter.from2)
        .value("specDim2To", this.specDimFilter.to2)
        .value("specDim3From", this.specDimFilter.from3)
        .value("specDim3To", this.specDimFilter.to3)
        .value("specDim4From", this.specDimFilter.from4)
        .value("specDim4To", this.specDimFilter.to4)
        // Ellenőrzés-mód (balance|posting|mixed) — a backend a hibás fejekre szűkít, a többi szűrővel ÉS kapcsolatban
        .value("checkType", this.checkType)
        // Főkönyvi szám (kód): van-e a fejnek tétele ezen az fksz-en — a többi szűrővel ÉS kapcsolatban
        .value("accno", this.accno)
        // Összepontozás-mód: a backend a K2D tétel-választó fej-feltételeit is ráteszi (sztornó kizárva, trans_type)
        .value("reconMode", this.basket.mode.active ? "true" : "")
      ;

      const filter = this.apiSearch?.filter?.fromFilter(extrafilter.toObject());
      this.apiSearch.filter = filter;

      //! Can be cancelled
      this.loading = true;
      try {
        const result = await this.api.post(this.$props.url, this.apiSearch);
        // console.log(result);
        if (result) {
          this.totalItems = result.totalCount;
          this.items = this.hasDetails
            ? result.currentPage.map((i) => {
                // Add custom detailsField prop
                Object.defineProperty(i, this.$props.detailsField, {
                  value: this.$props.openDetailsByDefault,
                  writable: true,
                  enumerable: true,
                  configurable: true,
                });

                return i;
              })
            : result.currentPage;

          // Összepontozás-módban a fejek tételei automatikusan lenyílnak (a tétel-sorok a kosár célpontjai).
          // A detailsField ('selected') a Kendo expand-field; a hasDetails-ág itt nem fut (nincs details slot).
          if (this.basket.mode.active) {
            (this.items || []).forEach((i: any) => { i[this.$props.detailsField] = true; });
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      } finally {
        console.log(this.apiSearch);
        this.loading = false;
      }

      this.$emit("itemCount", this.items?.length ?? 0);
      this.$emit("items", this.items);

      this.addFilterWIdthEventListeners();
    },

    pagerChanged(pager: PaginatedPager): void {
      if (
        // block double API calls from: search change -> pager update
        pager.totalItems === 0 ||
        (this.apiSearch.currentPage === pager.currentPage && this.apiSearch.pageSize === pager.pageSize)
      )
        return;

      this.apiSearch.currentPage = pager.currentPage;
      this.apiSearch.pageSize = pager.pageSize;
      this.changeHandler();
    },

    getFieldOrder(field: string): SortOrder {
      return this.apiSearch.sort?.definitions.find((x) => x.field === field)?.order ?? SortOrder.None;
    },

    toggleSort(field: string): void {
      this.apiSearch.sort?.toggle(field);
    },

    getHeaderClasses,
    getFieldClasses,
    getAltRow,

    toggleExtraFilterVisibility() {
      this.isFilterVisible = !this.isFilterVisible;
      this.$emit("efilter-toggle", this.isFilterVisible);
    },

    onToggleSpecDimColumns() {
      if (this.specDimColumnsVisible && this.apiSearch?.filter) {
        ["specDim1", "specDim2", "specDim3", "specDim4"].forEach((f) => {
          const flt = (this.apiSearch.filter as any).filters[f];
          if (flt) {
            flt.value = null;
          }
        });
      }
      this.$emit("toggleSpecDimColumns");
    },
  },

  computed: {
    periodColumns: () => [
      {
        cell: "addTemplate",
        width: 50,
        filterable: false
      },
      {
        field: "id",
        title: t("Azonosito")
      },
      {
        field: "name",
        title: t("Periodus")
      },
      {
        field: "startDate",
        title: t("Kezdodatum"),
        cell: "startDateTemplate"
      },
      {
        field: "endDate",
        title: t("Vegdatum"),
        cell: "endDateTemplate"
      },
      {
        field: "mustCloseString",
        title: t("ZarasKotelezo")
      },
      {
        field: "status",
        title: t("Allapot")
      },
      {
        field: "creator",
        title: t("Letrehozo")
      },
    ],

    hasNoItems(): boolean {
      return (this.items?.length ?? 0) < 1;
    },

    hasCustomTable(): boolean {
      return !!this.$scopedSlots.customTable || !!this.$slots.customTable;
    },

    hasCustomTableBody(): boolean {
      return !!this.$scopedSlots.customTableBody || !!this.$slots.customTableBody;
    },

    hasDetails(): boolean {
      return !!this.$scopedSlots.details || !!this.$slots.details;
    },

    hasListView(): boolean {
      return !!this.$scopedSlots.listView || !!this.$slots.listView;
    },

    hasFilters(): boolean {
      return !!this.$scopedSlots.filters || !!this.$slots.filters;
    },

    specDimCapsules(): { key: string; text: string; from: string; to: string }[] {
      const names = [t("Munkaszam"), t("Gepjarmu"), t("Szerelo"), t("Szerviztipus")];
      const f = this.specDimFilter as any;
      return names
        .map((name, i) => ({
          key: `specdim${i + 1}`,
          text: `${name}: ${f[`from${i + 1}`] || ""} - ${f[`to${i + 1}`] || ""}`,
          from: `from${i + 1}`,
          to: `to${i + 1}`,
        }))
        .filter((c, i) => !!(f[`from${i + 1}`] || f[`to${i + 1}`]));
    },

    checkLabel(): string {
      return this.checkOptions.find((c) => c.value === this.checkType)?.title ?? "";
    },
    // Az Állapot lenyíló elemei; a tiltás a kijelölt tranzakció státuszától függ (a korábbi 5 gomb szabályai)
    statusActions() {
      const st = this.selectedItemStatus;
      return [
        { value: 2, title: t("ElokeszitesAlatt"), disabled: st == 2 || st == 6 },
        { value: 3, title: t("Ellenorizheto"), disabled: st >= 3 },
        { value: 4, title: t("Ellenorizve"), disabled: st >= 4 || st == 2 },
        // K2D w_resp_trans pb_stat5: csak Ellenőrizve (4) állapotból nyílik — a gomb/Alt+A javításával
        // egyező szabály (ld. TransactionEditor.vue), itt korábban hiányzott.
        { value: 5, title: t("KonyvekbenSzerepel"), disabled: st >= 5 || st < 4 },
        { value: 6, title: t("Torolt"), disabled: st >= 6 || [4, 5].includes(st) },
      ];
    },
    reconLabel(): string {
      const parts = [t("Osszepontozas", [this.basket.mode.year ?? ""])];
      if (this.basket.mode.accno) {
        parts.push(`fksz ${this.basket.mode.accno}`);
      }
      parts.push(t("TetelAKosarban", [this.basket.items.length]));
      return parts.join(", ");
    },
    hasSelectedTransaction(){
      if(this.hasNoItems){
        return false
      }else{
        let count = 0;
        let found = null;
        for (const item of this.items) 
        { 
          if ((item as Transaction).selectedStatus){
            count++;
            found = item;
          }
        }
        if(count == 1){
          console.log((found as any).status);
          this.setSelectedItemStatus((found as any).status)
        }else if(count > 1){
          this.setSelectedItemStatus(1)
        }else{
          this.setSelectedItemStatus(6)
        }
        return this.items.some((x: any) => x.selectedStatus)
      }
    },
  },
});
